// @generated by protoc-gen-connect-query v1.4.2
// @generated from file fingertip/creator/group_class/v1/group_class.proto (package fingertip.creator.group_class.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { MethodKind } from "@bufbuild/protobuf";
import { BookGroupClassPublicRequest, BookGroupClassPublicResponse, CancelGroupClassRequest, CancelGroupClassResponse, CompleteGroupClassRequest, CompleteGroupClassResponse, CreateGroupClassesRequest, CreateGroupClassesResponse, DeleteGroupClassRequest, DeleteGroupClassResponse, GetCustomerGroupClassesRequest, GetCustomerGroupClassesResponse, GetGroupClassesInRangeRequest, GetGroupClassesInRangeResponse, GetGroupClassesPublicRequest, GetGroupClassesPublicResponse, GetGroupClassesRequest, GetGroupClassesResponse, GetGroupClassRequest, GetGroupClassResponse, UpdateGroupClassRequest, UpdateGroupClassResponse } from "./group_class_pb.js";

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.CreateGroupClasses
 */
export const createGroupClasses = {
  localName: "createGroupClasses",
  name: "CreateGroupClasses",
  kind: MethodKind.Unary,
  I: CreateGroupClassesRequest,
  O: CreateGroupClassesResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.UpdateGroupClass
 */
export const updateGroupClass = {
  localName: "updateGroupClass",
  name: "UpdateGroupClass",
  kind: MethodKind.Unary,
  I: UpdateGroupClassRequest,
  O: UpdateGroupClassResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.DeleteGroupClass
 */
export const deleteGroupClass = {
  localName: "deleteGroupClass",
  name: "DeleteGroupClass",
  kind: MethodKind.Unary,
  I: DeleteGroupClassRequest,
  O: DeleteGroupClassResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.GetGroupClass
 */
export const getGroupClass = {
  localName: "getGroupClass",
  name: "GetGroupClass",
  kind: MethodKind.Unary,
  I: GetGroupClassRequest,
  O: GetGroupClassResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.GetGroupClasses
 */
export const getGroupClasses = {
  localName: "getGroupClasses",
  name: "GetGroupClasses",
  kind: MethodKind.Unary,
  I: GetGroupClassesRequest,
  O: GetGroupClassesResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.GetGroupClassesInRange
 */
export const getGroupClassesInRange = {
  localName: "getGroupClassesInRange",
  name: "GetGroupClassesInRange",
  kind: MethodKind.Unary,
  I: GetGroupClassesInRangeRequest,
  O: GetGroupClassesInRangeResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.CancelGroupClass
 */
export const cancelGroupClass = {
  localName: "cancelGroupClass",
  name: "CancelGroupClass",
  kind: MethodKind.Unary,
  I: CancelGroupClassRequest,
  O: CancelGroupClassResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.CompleteGroupClass
 */
export const completeGroupClass = {
  localName: "completeGroupClass",
  name: "CompleteGroupClass",
  kind: MethodKind.Unary,
  I: CompleteGroupClassRequest,
  O: CompleteGroupClassResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.GetGroupClassesPublic
 */
export const getGroupClassesPublic = {
  localName: "getGroupClassesPublic",
  name: "GetGroupClassesPublic",
  kind: MethodKind.Unary,
  I: GetGroupClassesPublicRequest,
  O: GetGroupClassesPublicResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.BookGroupClassPublic
 */
export const bookGroupClassPublic = {
  localName: "bookGroupClassPublic",
  name: "BookGroupClassPublic",
  kind: MethodKind.Unary,
  I: BookGroupClassPublicRequest,
  O: BookGroupClassPublicResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};

/**
 * @generated from rpc fingertip.creator.group_class.v1.GroupClassService.GetCustomerGroupClasses
 */
export const getCustomerGroupClasses = {
  localName: "getCustomerGroupClasses",
  name: "GetCustomerGroupClasses",
  kind: MethodKind.Unary,
  I: GetCustomerGroupClassesRequest,
  O: GetCustomerGroupClassesResponse,
  service: {
    typeName: "fingertip.creator.group_class.v1.GroupClassService"
  }
};
